<template>
 <div class="avue-logo">
   <!-- <transition name="fade">
      <span v-if="getScreen(isCollapse)" class="avue-logo_subtitle" key="0">
        {{ website.logo }}
      </span>
    </transition> -->
   <transition-group name="fade">
      <template v-if="getScreen(!isCollapse)">
		 <!-- <el-image 
		  	src="https://lz-sy.oss-cn-shenzhen.aliyuncs.com/app/logo_title.png"
		    fit="cover" style="height:36px"></el-image> -->
		  
        <span class="avue-logo_title" key="1">{{ website.indexTitle }} </span>
      </template>
    </transition-group>
  </div>
	<!-- <div class="avue-logo">

		
		<transition name="fade">
			<div style="margin: 5px 20px; display: flex; align-items: center; align-content: space-between;">
			
				<el-image style="width: 40px; height: 40px"
					src="https://lzzx-suyuan.oss-cn-hangzhou.aliyuncs.com/%E4%B8%A4%E6%8C%87%E6%BA%AF%E6%BA%90-png.png"
					fit="fit"></el-image>
				<span  key="0" style="margin-left: 8px;" class="avue-logo_subtitle">
					{{ website.indexTitle }}
				</span>
			</div>
		</transition>
		<transition-group name="fade">
			<template v-if="getScreen(!isCollapse)">
				<span class="avue-logo_title" key="1">{{ website.indexTitle }} </span>
			</template>
		</transition-group>
	</div> -->
</template>

<script>
	import {
		mapGetters
	} from 'vuex';

	import {
		setStore,
		getStore
	} from 'utils/store';

	export default {
		name: 'logo',
		data() {
			return {};
		},
		created() {

			let them = getStore('themeName');
			console.log(them)
		},
		computed: {
			...mapGetters(['isCollapse', 'themeName']),
		},
		methods: {},
	};
</script>